// Resolves a stored image URL (possibly relative like /api/uploads/...)
// into a fully-qualified URL using REACT_APP_BACKEND_URL.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  return `${BACKEND_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

// Picks the main image for a garment object (gallery first, then legacy image_url)
export const getMainImage = (garment) => {
  if (!garment) return '';
  if (Array.isArray(garment.images) && garment.images.length > 0) {
    return garment.images[0];
  }
  return garment.image_url || '';
};

// Adds ?w= to internal /api/uploads/ images so the backend serves a light WebP
export const optimizedImageUrl = (url, width) => {
  const resolved = resolveImageUrl(url);
  if (!resolved || !resolved.includes('/api/uploads/')) return resolved;
  if (/\.(mp4|mov|webm|m4v)(\?|$)/i.test(resolved)) return resolved;
  const sep = resolved.includes('?') ? '&' : '?';
  return `${resolved}${sep}w=${width}`;
};
